var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRankSilverNoRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.817C8.65 2.817 2.816 8.65 2.816 16c0 1.633.35 3.15.817 4.55L20.55 3.633c-1.4-.583-2.917-.816-4.55-.816z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 3.633L3.634 20.55C5.5 25.683 10.284 29.183 16 29.183c7.35 0 13.184-5.95 13.184-13.183 0-5.717-3.5-10.5-8.634-12.367z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2zm0 25.667c-6.417 0-11.667-5.25-11.667-11.667S9.583 4.333 16 4.333 27.667 9.583 27.667 16 22.417 27.667 16 27.667z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 14.717c-1.75-.584-1.75-.584-1.983-.7-.584-.35-.817-.7-.817-1.284 0-.933.817-1.633 1.983-1.633.934 0 1.867.467 2.684 1.283l1.75-2.1c-1.284-1.166-2.8-1.866-4.434-1.866-2.8 0-4.9 1.866-4.9 4.316 0 2.1 1.284 3.384 4.434 4.434 1.166.35 1.4.466 1.75.7.583.35.933.816.933 1.516 0 1.05-.933 1.75-2.333 1.75-1.167 0-2.45-.7-3.384-1.866l-1.75 1.983c1.284 1.633 3.15 2.45 5.134 2.45 3.15 0 5.25-1.867 5.25-4.433-.117-2.217-1.4-3.617-4.317-4.55z",
    fill: "#646464"
  })));
}

export default SvgIconRankSilverNoRibbon;